export default class BillerService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('billers/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('billers', params)
	}

	createEntity(params) {
		return this.apiService.callPost('billers', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('billers/' + id, params)
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('billers/' + id, params)
	}

	getEntitiesForSelectBox(params) {
		return this.apiService.callGet('billers/simple', params)
	}
}



// WEBPACK FOOTER //
// ./src/service/BillerService.js